import type { LogoType } from '../../types';

export const trustIndex: LogoType[] = [
  {
    id: '8034a182',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo2.png',
        name: 'logo2.png',
        alt: '',
        width: 300,
        height: 261
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '909b3e6f',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo3.png',
        name: 'logo3.png',
        alt: '',
        width: 297,
        height: 300
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: '6244c849',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo5.png',
        name: 'logo5.png',
        alt: '',
        width: 228,
        height: 300
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  },
  {
    id: 'd98df06f',
    file: {
      data: {
        url: 'https://elfsight.com/assets/logo-showcase/test-data/logo11.png',
        name: 'logo11.png',
        alt: '',
        width: 297,
        height: 260
      }
    },
    link: {
      value: 'https://elfsight.com/',
      rawValue: 'https://elfsight.com/',
      target: '_self',
      type: 'url'
    },
    caption: '',
    size: 100
  }
];
